/** @format */

import i18n from '../core/i18n';

export class ServiceCodeHelper {}

export class ServiceCodeHistoryHelper {
    static OPERATION_TYPES = {
        SERVICE_CODE: 'ServiceCode',
        FRACTION_SERVICE_CODE: 'FractionServiceCode',
    };

    public static getOperationTypesList = (): Array<{ name: string; value: string }> => {
        return [
            { name: 'service_code:his.operation_type_service_code', value: ServiceCodeHistoryHelper.OPERATION_TYPES.SERVICE_CODE },
            {
                name: 'service_code:his.operation_type_fraction_service_code',
                value: ServiceCodeHistoryHelper.OPERATION_TYPES.FRACTION_SERVICE_CODE,
            },
        ];
    };

    public static getOperationType = (operationType: string): string | null => {
        switch (operationType) {
            case ServiceCodeHistoryHelper.OPERATION_TYPES.SERVICE_CODE:
                return i18n.t('service_code:his.operation_type_service_code');
            case ServiceCodeHistoryHelper.OPERATION_TYPES.FRACTION_SERVICE_CODE:
                return i18n.t('service_code:his.operation_type_fraction_service_code');
            default:
                return null;
        }
    };

    public static getDetails = (
        entityType: string,
        crudOperation: string,
        field: string,
        lastValue: string | null,
        newValue: string | null
    ): string => {
        switch (crudOperation) {
            case 'INSERT':
                return ServiceCodeHistoryHelper.prepareInsertDetail(entityType, field, lastValue, newValue);
            case 'UPDATE':
                return ServiceCodeHistoryHelper.prepareUpdateDetail(entityType, field, lastValue, newValue);
            case 'DELETE':
                return ServiceCodeHistoryHelper.prepareDeleteDetail(entityType, field, lastValue, newValue);
            default:
                return '';
        }
    };

    private static prepareInsertDetail = (entityType: string, field: string, lastValue: string | null, newValue: string | null): string => {
        if (entityType === ServiceCodeHistoryHelper.OPERATION_TYPES.FRACTION_SERVICE_CODE) {
            return i18n.t('service_code:his.category_add', { category: newValue });
        } else if (entityType === ServiceCodeHistoryHelper.OPERATION_TYPES.SERVICE_CODE) {
            return i18n.t('service_code:his.in_field_add', { field: ServiceCodeHistoryHelper.matchFieldWithTranslation(field), value: newValue });
        }

        return '';
    };

    private static prepareUpdateDetail = (entityType: string, field: string, lastValue: string | null, newValue: string | null): string => {
        return i18n.t('service_code:his.in_field_change', {
            field: ServiceCodeHistoryHelper.matchFieldWithTranslation(field),
            lastValue: lastValue,
            newValue: newValue,
        });
    };

    private static prepareDeleteDetail = (entityType: string, field: string, lastValue: string | null, newValue: string | null): string => {
        if (entityType === ServiceCodeHistoryHelper.OPERATION_TYPES.FRACTION_SERVICE_CODE) {
            return i18n.t('service_code:his.category_deleted', { category: lastValue });
        } else if (entityType === ServiceCodeHistoryHelper.OPERATION_TYPES.SERVICE_CODE) {
            return '';
        }

        return '';
    };

    private static matchFieldWithTranslation = (field: string): string => {
        switch (field) {
            case 'text':
                return i18n.t('service_code:f.text');
            case 'description':
                return i18n.t('service_code:f.description');
            default:
                return '';
        }
    };
}
